export const API_STATUS = {
  success: 'success',
  error: 'error',
}